import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { FarmersDropDownDto } from './farmer-dropdown.dto';


export class FarmersDropDownResponseModel extends GlobalResponseObject {
    data?: FarmersDropDownDto[];
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: FarmersDropDownDto[]){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

